export enum ParcelListElementStatus {
  SELECTABLE = 'selectable',
  ADDED = 'added',
  SELECTED = 'selected'
}
